import React, { ForwardedRef, RefObject, useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { TextField, TextFieldProps } from 'new/elements/TextField';

const LoginTextField = React.forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const { classes, type, InputProps, ...otherProps } = props;

  const toggleVisibility = () => {
    setShowPassword((show) => !show);
  };

  return (
    <TextField
      ref={ref}
      fullWidth
      type={showPassword ? 'text' : type}
      variant="outlined"
      margin="dense"
      InputProps={{
        ...InputProps,
        endAdornment:
          type === 'password' ? (
            <InputAdornment position="end">
              <IconButton onClick={toggleVisibility} tabIndex={-1}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
      inputProps={{
        autoComplete: 'new-password',
      }}
      {...otherProps}
    />
  );
});

export default LoginTextField;
